import { object } from 'common/helpers'


export const initialState = {
  isFetching: false,
  products: [],
}

export const setFetching = (state, payload) => (
  object.set(state, 'isFetching', payload)
)

export const setProducts = (state, payload) => (
  {
    ...state,
    isFetching: false,
    products: payload,
  }
)
